<script>
    import {onDestroy} from 'svelte';
    import {APP_PATH} from "../lib/constants";
    import R, {LOADER} from "../lib/requests";
    import orders from "../stores/orders";
    import {copyObject, getDate, setFocusTo} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import Alert from "../stores/alerts";
    import PageHeader from "../components/PageHeader.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import ClientControl from "../components/controls/ClientControl.svelte";
    import OrderSample from "./OrderSample.svelte";
    import CodeControl from "../components/controls/CodeControl.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import OrderPdfOptions from "./OrderPdfOptions.svelte";
    import PdfModal from "./PdfModal.svelte";
    import A from "../lib/Router/A.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";
    import TimeControl from "../components/controls/TimeControl.svelte";

    export let orderId = null;

    let order = null;
    let isLocked = false;
    let analysesGroups = [];
    let client = null;
    let orderDate = null;
    let pageTitle = '';
    let unloadEventInitialized = false;

    let nextSampleCode = 0;
    let showPdfOptions = false;
    let selectedSamples = []; // selected samples to export to pdf
    let printItems = null;
    let notFound = false;

    let is_checked = 0;

    let pageHeaderControls = [
        {id: 'save', name: 'ΕΝΗΜΕΡΩΣΗ', tip: 'ενημέρωση εντολής', class: 'hidden-xs'},
        {
            id: 'save',
            name: '',
            tip: 'ενημέρωση εντολής',
            icon: 'save',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
        {id: 'unlock', name: '', tip: 'ξεκλείδωμα στοιχείων εντολής', icon: 'lock', hidden: orderId == 0},
        {id: 'lock', name: '', tip: 'κλείδωμα στοιχείων εντολής', icon: 'lock-open', hidden: true},
        {id: 'add', name: '', tip: 'προσθήκη δείγματος', icon: 'plus-circle'},
        {id: 'print', name: '', tip: 'δημιουργία pdf', icon: 'pdf'},
    ];

    const breadcrumb = [
        {id: 'orders', name: 'Εντολές', link: `/app/orders`}
    ];

    const beforeUnloadListener = (event) => {
        event.preventDefault();
        return (event.returnValue = "");
    };

    const initialize = () => {

        const onSuccess = result => {

            analysesGroups = result.analyses_groups;
            nextSampleCode = parseInt(result.next_sample_code);

            if (orderId == 0) {
                order = {
                    id: 0,
                    client_id: 0,
                    code: result.code,
                    is_approved: 0,
                    notes: '',
                    date_at: getDate(),
                    time_at: null,
                    samples: [],
                }
                setOrderData();
                $orders.orderIsDirty = false;
            } else {
                load();
            }
        }

        const onFailure = err => {
        };

        R.handle(R.order.initialize, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const setOrderData = () => {
        if (!order.samples.length) {
            order.samples.push(emptySample());
        }

        orderDate = order.date_at;

        let index = 1;
        order.samples.map(item => {
            item.index = index;
            item.is_locked = 1;
            item.is_collapsed = ~~item.is_collapsed;
            index++;
        });
    }

    const emptySample = () => {
        return {
            id: 0,
            index: getNextSampleIndex(),
            code: getNextSampleCode(),
            reference_no: '',
            type: '',
            characterization: '',
            sampling_from: '',
            sampling_method: '',
            edition: 1,
            location: '',
            temperature: '',
            analysis_interval: '',
            analysts: '',
            carriage_conditions: '',
            package: '',
            position: '',
            matrix: '',
            status: '',
            print_rows: [],
            delivered_at: order.date_at,
            delivered_time: null,
            analysis_start_at: null,
            analysis_start_time: null,
            analysis_end_at: null,
            analysis_end_time: null,
            is_acceptable: 0,
            is_checked: 0,
            with_logo: 0,
            is_locked: 0,
            is_collapsed: 0,
            is_on_cloud: 0,
            analyses: []
        }
    }

    const load = () => {
        const onSuccess = result => {
            order = result;
            client = order.client;
            delete (order.client);
            setOrderData();
            $orders.orderIsDirty = false;
            isLocked = true;
        }

        const onFailure = err => {
            if (err.code === 'not_found') {
                notFound = true;
            }
        };

        R.handle(R.order.details, orderId, onSuccess, onFailure, LOADER.PAGE);
    }

    const save = () => {

        const onSuccess = result => {
            order = result;
            orderId = result.id;
            setOrderData();
            $orders.changed = true;
            $orders.orderIsDirty = false;
            Notifier.showMessage("Η εντολή ενημερώθηκε");
        }

        const onFailure = err => {
            if (err.code && err.code === 'same_object_identifier') {
                if (err.params.order_code) {
                    Alert.warning("Ενημέρωση εντολής", `Υπάρχει ήδη καταχωρημένη εντολή με τον κωδικό "${err.params.order_code}"!`, () => setFocusTo("orderCode"));
                    return;
                }
                if (err.params.sample) {
                    Alert.warning("Ενημέρωση εντολής", `Υπάρχει ήδη καταχωρημένο δείγμα με τον κωδικό "${err.params.code}"`, () => setFocusTo(`sampleCode-${err.params.sample}`));
                }
            }
        };

        let action = orderId == 0 ? 'create' : 'edit';
        R.handle(R.order[action], order, onSuccess, onFailure, LOADER.POPUP);
    }

    const getNextSampleIndex = () => {
        let index = 0;
        order.samples.map(item => {
            if (index < item.index) {
                index = item.index;
            }
        });
        index++;
        return index;
    }

    const getNextSampleCode = () => {
        if (!order.samples.length) {
            return nextSampleCode;
        }

        let code = 0;
        order.samples.map(item => {
            let itemCode = parseInt(item.code);
            if (itemCode && code < itemCode) {
                code = itemCode;
            }
        });
        code++;

        return code;
    }

    const onAddSample = () => {
        let newSample = emptySample();
        if (order.samples.length) {
            let lastSample = order.samples[order.samples.length - 1];
            newSample.sampling_from = lastSample.sampling_from;
            newSample.temperature = lastSample.temperature;
            newSample.analysis_interval = lastSample.analysis_interval;
            newSample.carriage_conditions = lastSample.carriage_conditions;
            newSample.status = lastSample.status;
            newSample.delivered_at = lastSample.delivered_at;
            newSample.delivered_time = lastSample.delivered_time;
            newSample.analysis_start_at = lastSample.analysis_start_at;
            newSample.analysis_start_time = lastSample.analysis_start_time;
            // newSample.is_sealed = lastSample.is_sealed;
            newSample.analysts = lastSample.analysts;
            newSample.is_checked = 0;
            newSample.with_logo = lastSample.with_logo;
        }
        order.samples = [...order.samples, newSample];
        $orders.orderIsDirty = true;
        Notifier.showMessage("Δημιουργήθηκε νέο δείγμα στην εντολή.");
        setFocusTo(`sampleType-${newSample.index}`);
    }

    const onCloneSample = ({detail}) => {
        let newSample = copyObject(detail);
        newSample.id = 0;
        newSample.index = getNextSampleIndex();
        newSample.code = getNextSampleCode();
        newSample.characterization = '';
        order.samples = [...order.samples, newSample];
        $orders.orderIsDirty = true;
        Notifier.showMessage("Δημιουργήθηκε νέο δείγμα στην εντολή.");
    }

    const onCopySample = ({detail}) => {
        let newSample = emptySample();
        newSample.code = '';
        newSample.analyses = copyObject(detail.analyses);
        order.samples = [...order.samples, newSample];
        $orders.orderIsDirty = true;
        Notifier.showMessage("Δημιουργήθηκε νέο δείγμα στην εντολή.");
    }

    const onDeleteSample = ({detail}) => {
        Alert.delete("Διαγραφή δείγματος", "Να διαγραφεί το δείγμα από την εντολή;", () => deleteSample(detail));
    }

    const deleteSample = (sample) => {
        if (sample.id) {
            order.samples = order.samples.filter(x => x.id != sample.id);
        } else {
            order.samples = order.samples.filter(x => x.index != sample.index);
        }

        if (!order.samples.length) {
            order.samples.push(emptySample());
        }

        $orders.orderIsDirty = true;
    }

    const onPrint = () => {
        if (!order.id) {
            Alert.warning("Δημιουργία PDF", "Πρέπει να αποθηκεύσετε την νέα εντολή για να γίνει η εξαγωγή σε PDF αρχείο.");
            return;
        }

        if (!order.samples.filter(x => x.id > 0).length) {
            Alert.warning("Δημιουργία PDF", "Η εντολή δεν περιέχει αποθηκευμένα δείγματα.\nΠροσθέστε τα δείγματα και αποθηκεύστε την εντολή.");
            return;
        }

        if ($orders.orderIsDirty) {
            Alert.confirm("Δημιουργία PDF", "Η εντολή έχει υποστεί αλλαγές που δεν έχετε αποθηκεύσει.\nΑυτές οι αλλαγές δεν θα εμφανιστούν στο έγγραφο.\nΘέλετε να συνεχίσετε με την δημιουργία του PDF;", () => {
                showPdfOptions = true;
            });
            return;
        }

        showPdfOptions = true;
    }

    const closePrintOptions = (param) => {
        showPdfOptions = false;
        if (param) {
            printItems = param;
        }
    }

    const onPrintSample = ({detail}) => {
        printItems = {
            object: 'samples',
            samples: [detail.id]
        };
    }

    const closePrint = () => {
        printItems = null;
    }

    const onClientChange = ({detail}) => {
        client = detail;
        order.client_id = detail ? detail.id : null;
        $orders.orderIsDirty = true;
    }

    const onOrderChange = () => {
        $orders.orderIsDirty = true;
    }

    const onOrderToggleLock = () => {
        isLocked = !isLocked;
        pageHeaderControls.map(item => {
            if (item.id === 'unlock') {
                item.hidden = !isLocked;
            } else if (item.id === 'lock') {
                item.hidden = isLocked;
            }
        });
        pageHeaderControls = pageHeaderControls;
    }

    const setPageHeaderControls = () => {
        pageHeaderControls.map(item => {
            if (item.id === 'save') {
                item.active = $orders.orderIsDirty;
            }
        });
        pageHeaderControls = pageHeaderControls;
    }

    const onToggleChecked = ({detail}) => {
        if (detail.checked) {
            order.samples.map(item => {
                item.is_checked = 1;
            });
            order.samples = order.samples;
        }
    }

    const onSubmit = () => {
        return false;
    }

    const unloadEventHandler = (event) => {
        event.preventDefault();
        event.returnValue = '';
    }

    onDestroy(() => {
        $orders.orderIsDirty = false;
        removeEventListener("beforeunload", beforeUnloadListener, {capture: true});
    });

    initialize();

    $: {
        if (order) {
            pageTitle = order.id == 0 ? 'Νέα Εντολή' : `Εντολή ${order.code}`;

            if (order.date_at != orderDate) {
                order.samples.map(item => {
                    if (item.id == 0) {
                        item.delivered_at = order.date_at;
                    }
                });
                orderDate = order.date_at;
                order.samples = order.samples;
            }

            // handle browser refresh or close events
            if ($orders.orderIsDirty && !unloadEventInitialized) {
                addEventListener("beforeunload", beforeUnloadListener, {capture: true});
                unloadEventInitialized = true;
                setPageHeaderControls();
            } else if (!$orders.orderIsDirty && unloadEventInitialized) {
                removeEventListener("beforeunload", beforeUnloadListener, {capture: true});
                unloadEventInitialized = false;
                setPageHeaderControls();
            }
        }
    }
</script>
<Breadcrumb {breadcrumb}/>
{#if order}
    <PageHeader title="{ pageTitle }" subtitle="{ client ? client.company : ''}" controls={ pageHeaderControls } sticky
                on:save={ save }
                on:unlock={ onOrderToggleLock }
                on:lock={ onOrderToggleLock }
                on:add={ onAddSample }
                on:print={ onPrint }/>

    <div class="panel-simple panel-pad pb-1 mb-4">
        <form id="formOrder" on:submit|preventDefault|stopPropagation={ onSubmit }>
            <div class="row d-flex">
                <div class="col-xl-1 col-sm-3 col-6 mb-3">
                    <label class="text-truncate mb-0">Κωδικός Εντ.</label>
                    <CodeControl id="orderCode" bind:value="{ order.code }" on:change={ onOrderChange } isLocked
                                 disabled="{ isLocked }"/>
                </div>
                <div class="col-xl-2 col-sm-3 col-6 d-flex gap-2 mb-3">
                    <div>
                        <label>Ημερομηνία</label>
                        <input type="date" class="form-control" bind:value={order.date_at}
                               on:change={onOrderChange} disabled={isLocked}>
                    </div>
                    <div>
                        <label>Ώρα</label>
                        <TimeControl bind:value={order.time_at} on:change={onOrderChange} disabled={isLocked}/>
                    </div>
                </div>
                <div class="col-xl-3 col-sm-6 mb-3">
                    <label>Πελάτης</label>
                    <ClientControl bind:client={ client } on:change={ onClientChange } disabled="{ isLocked }"/>
                </div>
                <div class="col-xl-2">
                    <!--                    <div class="mb-3">-->
                    <!--                        <label>Σχόλιο</label>-->
                    <!--                        <input type="text" class="form-control" bind:value="{ order.notes }"-->
                    <!--                               on:change={ onOrderChange } disabled="{ isLocked }">-->
                    <!--                    </div>-->
                </div>
                <div class="col-xl-2 col-lg-2 mb-3">
                    <Checkbox label="Έλεγχος όλων" spaceTopLg bind:checked={is_checked}
                              on:change={onToggleChecked} disabled={isLocked}/>
                </div>
                <div class="col-xl-2 col-lg-2 mb-3">
                    <Checkbox label="Έγκριση εντολής" spaceTopLg bind:checked={ order.is_approved }
                              on:change={ onOrderChange } disabled="{ isLocked }"/>
                </div>
            </div>
        </form>
    </div>
    {#each order.samples as sample}
        <OrderSample bind:sample={ sample } {analysesGroups} clientId="{ order.client_id }"
                     allowOnCloud="{ client ? client.cloud_key != null : false }"
                     on:change={ onOrderChange }
                     on:clone={ onCloneSample }
                     on:copy={ onCopySample }
                     on:print={ onPrintSample }
                     on:delete={ onDeleteSample }
        />
    {/each}

    <div class="panel-simple panel-pad mt-4">
        <div class="row d-flex align-items-center">
            <div class="col-xl-6 col-lg-6 col-md-7 hidden-sm hidden-xs">
            </div>
            <div class="col-xl-6 col-lg-6 col-md-5 text-end">
                <A href="/{APP_PATH}/orders" class="btn btn-link me-4">Εντολές</A>
                <button class="btn" class:btn-primary={ !$orders.orderIsDirty }
                        class:btn-danger={ $orders.orderIsDirty } on:click={ save }>ΕΝΗΜΕΡΩΣΗ
                </button>
            </div>
        </div>
    </div>
{/if}

{#if notFound}
    <PageNotFound message="Η εντολή που ζητήσατε δεν βρέθηκε!"/>
{/if}

{#if showPdfOptions}
    <OrderPdfOptions orderId="{ order.id }" samples="{ order.samples }" bind:selected="{ selectedSamples }"
                     closeCallback="{ closePrintOptions }"/>
{/if}
{#if printItems}
    <PdfModal {printItems} closeCallback="{ closePrint }"/>
{/if}